import { Search, X } from "lucide-react";

export function SearchBox({
  value,
  placeholder,
  label,
  clearTitle = "清除搜尋",
  onChange
}: {
  value: string;
  placeholder: string;
  label: string;
  clearTitle?: string;
  onChange: (value: string) => void;
}) {
  return (
    <label className="search-box">
      <Search size={16} aria-hidden="true" />
      <input
        type="search"
        aria-label={label}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      {value ? (
        <button type="button" title={clearTitle} aria-label={clearTitle} onClick={() => onChange("")}>
          <X size={15} aria-hidden="true" />
        </button>
      ) : null}
    </label>
  );
}
